import { useMutation } from "@tanstack/react-query";
import { printExercises } from "../../queries/Print";
import { IExercisesPrint } from "../../models/Print";

const usePrintExercises = () => {
  const { mutate, data, isPending } = useMutation({
    mutationKey: ['get-exercises-print'],
    mutationFn: (body: IExercisesPrint) => printExercises(body),
    retry: false
  })

  return { mutate, data, isPending }
}

export default usePrintExercises;
